const AcceptedLoanReceive = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-3 mt-16">
      <div className="bg-farm-shop-500 flex items-center justify-center p-2 rounded-full aspect-square">
        <i className="icon-nameCheckmark font-semibold text-white text-3xl" />
      </div>
      <span className="text-xl font-bold">تایید کاربر برای تخصیص وام</span>

      <span className="text-md text-gray-700 my-4">
        امتیاز دریافت وام به نام شما منتقل شد. برای دریافت وام، وارد اپلکیشن
        بانک شوید و از قسمت وام سازمانی فرایند را ادامه دهید.
      </span>
    </div>
  );
};
export default AcceptedLoanReceive;
